module.exports = __webpack_public_path__ + "img/luowen.4b9f0371.png";